var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem9A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m206.58 23.182c-3.1213-3.1213-6.7627-4.6819-11.185-4.6819s-8.1933 1.5606-11.315 4.6819c-3.1213 3.1213-4.6819 6.8928-4.6819 11.315s1.5606 8.1933 4.6819 11.315c3.1213 3.1213 6.8928 4.6819 11.315 4.6819s8.0633-1.5606 11.185-4.6819 4.6819-6.8928 4.6819-11.315-1.5606-8.1933-4.6819-11.315z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.298 0 0 1.3005 203.35 24.892)",
    x: -10.01498,
    y: 12.30272,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "1"), /*#__PURE__*/React.createElement("path", {
    d: "m563.71 23.182c-3.1213-3.1213-6.7627-4.6819-11.185-4.6819s-8.1933 1.5606-11.315 4.6819c-3.1213 3.1213-4.6819 6.8928-4.6819 11.315s1.5606 8.1933 4.6819 11.315 6.8928 4.6819 11.315 4.6819 8.0633-1.5606 11.185-4.6819 4.6819-6.8928 4.6819-11.315-1.5606-8.1933-4.6819-11.315z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.298 0 0 1.3005 560.41 24.892)",
    x: -10.01498,
    y: 12.30272,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "2"), /*#__PURE__*/React.createElement("path", {
    d: "m387.49 168.06c-3.1213-3.1213-6.7627-4.6819-11.185-4.6819s-8.1933 1.5606-11.315 4.6819c-3.1213 3.1213-4.6819 6.8928-4.6819 11.315s1.5606 8.1933 4.6819 11.315 6.8928 4.6819 11.315 4.6819 8.0633-1.5606 11.185-4.6819 4.6819-6.8928 4.6819-11.315-1.5606-8.1933-4.6819-11.315z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.298 0 0 1.3005 384.25 169.77)",
    x: -10.01498,
    y: 12.30272,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "3"), /*#__PURE__*/React.createElement("path", {
    d: "m335.46 88.598v-7.543h-298.08v7.543h298.08z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.5 89.899v-9.7539h-300.16v9.7539h300.16m-2.2109-7.6731v5.4622h-295.87v-5.4622h295.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.54 137.76c0.78032-3.1213 1.1705-6.5026 1.0404-9.7539l-320.19 0.26011c0.91037 5.072 2.471 10.144 4.812 15.216 3.2513 4.0316 7.543 5.9824 13.005 5.5923 3.1213-0.13005 6.1125-0.39016 8.8436-1.0404 2.9912-0.65026 5.3322-0.91037 7.283-0.91037 1.5606 0 3.2513 0.13005 4.942 0.26011 1.1705 0 2.471 0 4.1617 0.13005 0.78032 0 1.6907 0 2.601-0.13005 5.2021 0.13005 9.7539 0.39016 13.656 0.91037 3.1213 0.52021 6.5026 0.78032 10.144 0.91037 1.5606 0.13005 3.3814 0 5.2021-0.26011 9.1037-1.6907 18.077-4.0316 26.921-6.8928 7.413-1.6907 14.826-2.471 22.369-2.601 3.6415-0.13005 7.283-0.26011 11.054-0.39016 1.8207 0 3.7715 0.13005 5.5923 0.39016 4.942 1.4306 9.884 3.1213 14.566 5.2021 2.9912 1.0404 5.8524 1.4306 8.5835 1.4306 4.2917-0.13005 8.5835-0.65026 12.875-1.6907 5.8524-1.0404 11.705-1.6907 17.427-1.6907 1.5606 0 3.1213 0 4.6819 0.13005 13.916 0.65026 27.831 1.5606 41.747 2.8612 4.812 0.52021 9.4938 0.78032 14.176 0.78032 4.2917 0.13005 8.7135-0.26011 12.875-1.0404 4.5518-1.8207 8.8436-3.6415 13.005-5.4622 2.7311-0.52021 4.6819-0.78032 5.5923-0.65026 1.1705 0 3.9016 0.52021 8.0633 1.5606 3.9016 1.0404 7.6731 1.6907 11.315 1.8207 1.1705 0 2.341-0.13005 3.6415-0.39016 4.6819 0.26011 7.9332-1.1705 10.014-4.5518z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.58 127.61-20.028-34.594-20.028 34.594h40.056z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.68 90.809-1.0404 1.5606-20.808 36.285h43.698l-21.849-37.845m17.947 35.634h-36.285l18.077-31.213 18.207 31.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.08 128.65v-2.2109h-332.28v2.2109h332.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.89 81.185-23.409-40.576h-27.831l-23.409 40.576h74.65z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.517 40.219-0.39016-0.65026h-29.132l-0.39016 0.65026-24.32 42.137h78.682l-24.45-42.137m-1.8207 1.4306 22.369 38.496h-71.269l22.369-38.496h26.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.62 81.185-23.279-40.576h-27.961l-23.409 40.576h74.65z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.57 82.226-24.71-42.787h-29.132l-0.39016 0.65026-24.32 42.137h78.552m-26.141-40.576 22.369 38.496h-71.269l22.369-38.496h26.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.66 97.572v-8.8436h-108.59v8.8436h18.077v-4.812h7.8032v4.812h8.4534v-4.812h7.543v4.812h8.7135v-4.812h7.543v4.812h8.4534v-4.812h7.543v4.812h8.7135v-4.812h7.543v4.812h18.207z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.7 98.612v-11.054h-110.8v11.054h20.158v-4.812h5.5923v4.812h10.664v-4.812h5.4622v4.812h10.924v-4.812h5.4622v4.812h10.664v-4.812h5.4622v4.812h10.924v-4.812h5.4622v4.812h20.028m-2.0808-8.8436v6.7627h-15.866v-4.812h-9.7539v4.812h-6.5026v-4.812h-9.7539v4.812h-6.2425v-4.812h-9.7539v4.812h-6.5026v-4.812h-9.7539v4.812h-6.2425v-4.812h-10.014v4.812h-16.127v-6.7627h106.51z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3007 0 0 1.3005 158.11 103.36)",
    x: -76.98826,
    y: -21.69728,
    fontFamily: "'ArialMT'",
    fontSize: "13.36px"
  }, "25kg"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3007 0 0 1.3005 367.04 103.36)",
    x: -76.98826,
    y: -21.69728,
    fontFamily: "'ArialMT'",
    fontSize: "13.36px"
  }, "50kg"), /*#__PURE__*/React.createElement("path", {
    d: "m696.49 88.598v-7.543h-298.21v7.543h298.21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m697.66 89.899v-9.7539h-300.42v9.7539h300.42m-2.2109-7.6731v5.4622h-296v-5.4622h296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m717.43 137.76c0.78032-3.1213 1.1705-6.5026 1.0404-9.7539l-319.93 0.26011c0.91037 5.072 2.341 10.144 4.5518 15.216 3.2513 4.0316 7.543 5.9824 13.005 5.5923 3.1213-0.13005 6.1125-0.39016 8.8436-1.0404 2.8612-0.65026 5.2021-0.91037 6.8928-0.91037 1.4306 0 2.9912 0.13005 4.4218 0.26011 1.0404 0 2.341 0 3.9016 0.13005 0.78032 0 1.6907 0 2.601-0.13005 5.2021 0.13005 9.4938 0.39016 13.005 0.91037 2.7311 0.52021 5.8524 0.78032 9.4938 0.91037 1.5606 0.13005 3.2513 0 5.072-0.26011 8.9736-1.6907 17.947-4.0316 26.921-6.8928 7.283-1.6907 14.826-2.471 22.369-2.601l10.924-0.39016c1.8207 0 3.7715 0.13005 5.5923 0.39016 5.2021 1.4306 10.014 3.1213 14.826 5.2021 2.9912 1.0404 5.8524 1.4306 8.5835 1.4306 4.2917-0.13005 8.5835-0.65026 12.875-1.6907 5.8524-1.0404 11.705-1.6907 17.427-1.6907 1.5606 0 3.1213 0 4.6819 0.13005 13.916 0.65026 27.831 1.5606 41.747 2.8612 4.6819 0.52021 8.8436 0.78032 12.485 0.78032 3.3814 0.13005 7.1529-0.26011 11.445-1.0404 5.3322-1.8207 10.664-3.6415 16.257-5.4622 2.7311-0.52021 4.942-0.78032 6.3726-0.65026 2.2109 0 5.4622 0.52021 9.884 1.5606 3.9016 1.0404 7.6731 1.6907 11.315 1.8207 1.1705 0 2.341-0.13005 3.6415-0.39016 4.4218 0.26011 7.6731-1.1705 9.7539-4.5518z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m583.47 127.61-19.768-34.594-20.028 34.594h39.796z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.84 90.809-1.0404 1.5606-20.808 36.285h43.698l-21.849-37.845m18.077 35.634h-36.285l18.077-31.213 18.207 31.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m721.2 128.65v-2.2109h-328.77v2.2109h328.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.04 81.185-23.409-40.576h-27.961l-23.409 40.576h74.78z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.54 40.219-0.26011-0.65026h-29.262l-0.26011 0.65026-24.32 42.137h78.422l-24.32-42.137m-1.5606 1.4306 22.109 38.496h-71.009l22.109-38.496h26.791z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m687.78 81.185-23.409-40.576h-27.961l-23.409 40.576h74.78z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m665.28 40.219-0.26011-0.65026h-29.262l-0.26011 0.65026-24.32 42.137h78.682l-24.58-42.137m-1.5606 1.4306 22.369 38.496h-71.269l22.369-38.496h26.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601.81 97.572v-8.8436h-108.59v8.8436h18.077v-4.812h7.543v4.812h8.7135v-4.812h7.543v4.812h8.4534v-4.812h7.543v4.812h8.7135v-4.812h7.543v4.812h8.4534v-4.812h7.543v4.812h18.467z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602.85 98.612v-11.054h-110.8v11.054h20.158v-4.812h5.4622v4.812h10.924v-4.812h5.4622v4.812h10.664v-4.812h5.4622v4.812h10.924v-4.812h5.4622v4.812h10.664v-4.812h5.4622v4.812h20.158m-2.2109-8.8436v6.7627h-16.127v-4.812h-9.7539v4.812h-6.2425v-4.812h-9.7539v4.812h-6.5026v-4.812h-9.7539v4.812h-6.2425v-4.812h-9.7539v4.812h-6.5026v-4.812h-9.7539v4.812h-15.866v-6.7627h106.25z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3007 0 0 1.3005 519.72 103.36)",
    x: -76.98826,
    y: -21.69728,
    fontFamily: "'ArialMT'",
    fontSize: "13.36px"
  }, "50kg"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3007 0 0 1.3005 728.24 100.98)",
    x: -76.98826,
    y: -21.69728,
    fontFamily: "'ArialMT'",
    fontSize: "13.36px"
  }, "25kg"), /*#__PURE__*/React.createElement("path", {
    d: "m525.86 219.04v-7.8032h-298.21v7.8032h298.21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.03 219.82v-10.014h-300.42v10.014h300.42m-2.2109-7.8032v5.5923h-296v-5.5923h296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.94 267.55c0.78032-3.1213 1.0404-6.3726 0.91037-9.7539l-346.2 0.39016c0.91037 4.942 2.341 10.014 4.5518 15.216 3.3814 4.0316 7.543 5.8524 12.875 5.5923 3.2513-0.13005 6.3726-0.52021 9.3638-1.1705 2.7311-0.52021 5.3322-0.78032 7.8032-0.78032 2.0808 0 4.1617 0.13005 6.2425 0.39016 1.6907 0 3.5114 0 5.3322 0.13005 0.91037 0 1.9508 0 2.9912-0.13005 0.91037-0.13005 1.9508-0.13005 2.9912-0.13005 4.5518 0.13005 9.1037 0.39016 13.786 1.0404 4.4218 0.39016 8.8436 0.65026 13.135 0.78032 1.9508 0 3.9016-0.13005 5.7223-0.39016 8.9736-1.6907 17.947-4.0316 26.921-6.8928 7.413-1.6907 14.826-2.471 22.369-2.341 3.5114-0.26011 6.8928-0.39016 10.404-0.52021 2.0808 0 4.0316 0.13005 6.1125 0.52021 5.2021 1.3005 10.014 2.9912 14.826 5.2021 2.7311 0.91037 5.4622 1.4306 8.1933 1.3005 4.2917-0.13005 8.8436-0.78032 13.395-1.6907 6.1125-1.0404 12.355-1.5606 18.598-1.5606 1.1705-0.13005 2.341-0.13005 3.6415 0 14.046 0.78032 27.961 1.8207 41.747 2.9912 4.5518 0.39016 9.1037 0.65026 13.656 0.78032 4.5518 0 8.9736-0.39016 13.525-1.0404 6.2425-1.6907 12.485-3.6415 18.728-5.5923 2.8612-0.39016 5.8524-0.65026 8.8436-0.65026 5.2021 0 10.274 0.52021 15.346 1.6907 4.0316 1.0404 7.9332 1.6907 11.575 1.8207 1.1705 0 2.341-0.13005 3.6415-0.39016 3.6415 0.13005 6.7627-1.4306 8.9736-4.812z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.59 257.67-19.768-34.594-20.028 34.594h39.796z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.84 258.58h43.698l-21.719-37.845-21.979 37.845m39.796-2.2109h-36.025l18.077-31.083 17.947 31.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.22 258.45v-2.2109h-358.55v2.2109h358.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.28 210.98-23.409-40.446h-27.961l-23.409 40.446h74.78z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.1 212.02-24.58-42.527h-29.262l-24.58 42.527h78.422m-25.75-40.316 21.979 38.235h-70.749l21.979-38.235h26.791z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m517.15 210.98-23.409-40.446h-27.961l-23.409 40.446h74.78z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.97 212.02-24.58-42.527h-29.262l-24.58 42.527h78.422m-25.75-40.316 21.979 38.235h-70.749l21.979-38.235h26.791z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.18 227.62v-8.8436h-108.85v8.8436h18.207v-4.812h7.543v4.812h8.4534v-4.812h7.8032v4.812h8.4534v-4.812h7.543v4.812h8.7135v-4.812h7.543v4.812h8.4534v-4.812h7.543v4.812h18.598z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.09 228.8v-11.054h-110.93v11.054h20.418v-4.812h5.4622v4.812h10.664v-4.812h5.5923v4.812h10.664v-4.812h5.4622v4.812h10.924v-4.812h5.4622v4.812h10.664v-4.812h5.4622v4.812h20.158m-2.0808-8.9736v6.7627h-16.127v-4.812h-9.7539v4.812h-6.2425v-4.812h-9.884v4.812h-6.5026v-4.812h-9.7539v4.812h-6.2425v-4.812h-10.014v4.812h-6.2425v-4.812h-9.7539v4.812h-16.127v-6.7627h106.64z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3007 0 0 1.3005 349.68 233.09)",
    x: -76.98826,
    y: -21.69728,
    fontFamily: "'ArialMT'",
    fontSize: "13.36px"
  }, "50kg"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3007 0 0 1.3005 558.06 230.7)",
    x: -76.98826,
    y: -21.69728,
    fontFamily: "'ArialMT'",
    fontSize: "13.36px"
  }, "25kg")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem9A);
export default __webpack_public_path__ + "static/media/item9a.200c328d03285c9a6d241d53c09e19a5.svg";
export { ForwardRef as ReactComponent };